import React from "react";
import { FaPen } from "react-icons/fa";
import { MdDelete, MdFastfood } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { deleteNourriture } from "../JS/actions/nourritures";

const Nourriture = ({ nourriture }) => {
  const dispatch = useDispatch();
  const handleDelete = () => {
    const result = window.confirm("are you sure");
    if (result) {
      dispatch(deleteNourriture(nourriture._id));
    }
  };
  return (
    <div class="main-container">
      <div class="heading">
        {/* <h1 class="heading__title">Stock Nourritures</h1> */}
      </div>
      <div class="cardss">
        <div class="cardd card-4">
          <div class="card__icon">
            <b> {nourriture.title} </b>
            <MdFastfood style={{ fontSize: "30px", color: "orange" }} />{" "}
          </div>
          <p class="card__exit">
            {/* <i class="fas fa-times"></i> */} Quantity : {nourriture.qte}
          </p>
          <p class="card__title">{nourriture.description}</p>
          <p class="card__apply">
            <a onClick={handleDelete} class="card__link" href="#">
              Delete{" "}
              <MdDelete
                onClick={handleDelete}
                style={{ color: "red", fontSize: "22px" }}
              />{" "}
            </a>{" "}
            <a onClick={handleDelete} class="card__link" href="#">
              Update{" "}
              <FaPen
                // onClick={handleEvent}
                style={{ color: "green", fontSize: "18px" }}
              />
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Nourriture;
